/* eslint-disable */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

function CallURL() {
  const [data, setData] = useState(null);
  const apiUrl = process.env.REACT_APP_APIHOST + '/url_callback';
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = new URLSearchParams(location.search);
        const token = query.get('token');
        // alert('Token: ' + token);
        const callbackToken = query.get('callbacktoken');
        let paymentResponse;

        if (token) {
          // Append token to apiUrl
          const apiUrlWithToken = `${apiUrl}?token=${token}`;
          paymentResponse = await axios.post(apiUrlWithToken);
          setData(paymentResponse.data);
        } else if (callbackToken) {
          paymentResponse = await axios.get(
            process.env.REACT_APP_APIHOST + '/decodeAuthToken',
            {
              headers: {
                Authorization: callbackToken,
              },
            },
          );
          setData(paymentResponse.data.source);
        } else {
          alert('Token not found.');
          navigate(-1); // ย้อนกลับไปหน้าก่อนหน้านี้
        }

        if (paymentResponse.status === 200) {
          if (
            paymentResponse.data.status === 'call merchant' ||
            paymentResponse.data.status === 'valid token'
          ) {
            const tagUrl =
              paymentResponse.data.tagUrl || paymentResponse.data.source.url;
            const tagInput =
              paymentResponse.data.tagInput ||
              paymentResponse.data.source.webhook.tag;

            // แปลงข้อมูล tagInput ให้เป็นรูปแบบที่ใช้ส่งไป API
            const parser = new DOMParser();
            const doc = parser.parseFromString(tagInput, 'text/html');
            const inputs = doc.querySelectorAll('input');

            const form = document.createElement('form');
            form.action = tagUrl;
            form.method = 'POST';
            form.style.display = 'none';

            inputs.forEach((input) => {
              const inputElement = document.createElement('input');
              inputElement.type = 'hidden';
              inputElement.name = input.name;
              inputElement.value = input.value;
              form.appendChild(inputElement);
            });

            document.body.appendChild(form);
            form.submit();
          } else if (paymentResponse.data.status === 'do not call merchant') {
            navigate(paymentResponse.data.pathUrl);
          } else if (paymentResponse.data.status === 'invalid token') {
            alert('invalid token');
            navigate(-1); // ย้อนกลับไปหน้าก่อนหน้านี้
          } else {
            console.error('No redirect URL found');
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData(); // เรียกใช้ฟังก์ชัน fetchData เมื่อคอมโพเนนต์ถูกสร้างขึ้นมาใหม่
  }, [location.search, navigate]);

  return (
    <div>
      <button disabled>Redirecting...</button>
    </div>
  );
}

export default CallURL;
